import OrganisationsSelect from '../../../elements/Select/Organistaions'
import {defaultFormItemLayout} from '../../../modules/FormItems'
import React from 'react'
import {Button, Col, DatePicker, Form, Row} from 'antd'
import {get} from 'lodash'
import {dateVal} from '../../../modules/Utils'

function BASForm(props) {
  const {bas, onGenerate, generating, isNew} = props
  const {getFieldDecorator, getFieldValue} = props.form

  return (
    <Form>
      <Row>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label="From">
            {getFieldDecorator('company._id', {
              initialValue: get(bas, 'company._id'),
              rules: [{required: true, message: 'Please Select a Company!'}],
            })(
              <OrganisationsSelect disabled={!isNew} style={{width: '200%'}} />,
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label="End Date">
            {getFieldDecorator('end', {
              initialValue: dateVal(bas, 'end'),
              rules: [{required: true, message: 'Please Select End Date!'}],
            })(<DatePicker disabled={!isNew} style={{width: '100%'}} />)}
          </Form.Item>
        </Col>
        {isNew && (
          <Col span={8}>
            <Button
              type={'primary'}
              style={{marginLeft: '25%'}}
              disabled={!getFieldValue('company._id') || !getFieldValue('end')}
              loading={generating}
              onClick={onGenerate}>
              Generate
            </Button>
          </Col>
        )}
      </Row>
    </Form>
  )
}

BASForm.propTypes = {}
BASForm.defaultProps = {}

export default Form.create()((BASForm))
